export { BC_TO_SHOPIFY_SKU_MAP, SHOPIFY_TO_BC_SKU_MAP } from './skuMaps';
